<div class="landing-page">
  <div class="landing-content">

    <h1 class="landing-heading">What would you like to do today?</h1>
    <p class="landing-sub">Select a platform to continue</p>

    <div class="product-cards">

      <button class="product-card card-planning"
              type="button"
              [disabled]="isRedirecting"
              (click)="goToTaxPlanning()">
        <div class="card-icon planning-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
            <polyline points="14 2 14 8 20 8"/>
            <line x1="16" y1="13" x2="8" y2="13"/>
            <line x1="16" y1="17" x2="8" y2="17"/>
            <polyline points="10 9 9 9 8 9"/>
          </svg>
        </div>
        <div class="card-body">
          <div class="card-title">Tax Planning</div>
          <div class="card-desc">Build proposals, ROI estimates, and tax plan reports. Sell tax planning up front and value-price the implementation work.</div>
        </div>
        <div class="card-arrow">
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
        </div>
      </button>

      <button class="product-card card-projections"
              type="button"
              [disabled]="isRedirecting"
              (click)="goToTaxProjections()">
        <span class="ribbon-wrapper">
          <span class="ribbon">Beta</span>
        </span>
        <span class="card-new-tag card-new-tag--bottom">NEW</span>
        <div class="card-icon projections-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
            <polyline points="17 6 23 6 23 12"/>
          </svg>
        </div>
        <div class="card-body">
          <div class="card-title">Tax Projections</div>
          <div class="card-desc">See what each client owes this year and model how tax-planning strategies change the bill. Outputs a quarterly payment plan.</div>
        </div>
        <div class="card-arrow">
          <ng-container *ngIf="isRedirecting; else arrow">
            <svg class="spinner" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
            </svg>
          </ng-container>
          <ng-template #arrow>
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2"><polyline points="9 18 15 12 9 6"/></svg>
          </ng-template>
        </div>
      </button>

    </div>
  </div>
</div>
